(function ($) {
	$(function () {
		$("section.product .photo").addClass("swiper");
		$("section.product .photo > ul").addClass("swiper-wrapper");
		$("section.product .photo > ul > li").addClass("swiper-slide");

		$("section.product .photo").each(function () {
			let $target	=	$(this);

			if($target.find(".swiper-slide").length >= 2) {
				$target.append('<span class="prev"></span>');
				$target.append('<span class="next"></span>');

				const swiper	=	new Swiper($target.get(0), {
					loop			:	true,
					navigation		:	{
						nextEl	:	'.next',
						prevEl	:	'.prev',
					},
				});
			}
		});
	});
})(jQuery);